import "./style.sass";
import "../map/style.sass";
//import Scrollbar from 'smooth-scrollbar';

import { initTooltip } from '../popover/index';

export function init($geographies) {
    // NLMK.fusionTables.onReady(() => {}); // предзагрузка FusionTables
    // NLMK.maps.onReady(function initSections() {
    //     $geographies.each(eachGeography);
    // });
    $geographies.each(eachGeography);
}

function eachGeography(geographyIndex, GeographyElement) {
    const $geography = $(GeographyElement);
    const $form = $geography.find('.js-geography-form');
    const $map = $geography.find('.geography__map');
    const $svgMap = $map.find('.map-section__map-wrapper > svg');
    const $asideContainer = $geography.find('.map-section__aside-container');

    const mapPoints = {
        url: $map.data('map-points-url'),
        method: $map.data('map-points-method'),
    };

    $('.js-geography-radio').change(() => {
        // временный хардкод для сдачи проекта клиенту - начало
        const $countryCheckedInput = $form.find('input[name="region"]:checked');
        const country = $countryCheckedInput[0].id.replace('radio-region-', '');
        mapPoints.url = $map.data('map-points-url').replace('.json', '-' + country + '.json');
        // временный хардкод для сдачи проекта клиенту - конец

        requestPoints();
    });

    const markers = [];

    requestPoints();

    $form.on('submit', onFormSubmit);

    // const mapScrollbar = Scrollbar.init($map[0], {
    //     damping: 0.06,
    //     thumbMinSize: 33,
    //     renderByPixels: true,
    //     alwaysShowTracks: false,
    //     continuousScrolling: true
    // });

    function initMapEvents() {
        let curXPos = 0;
        let curYPos = 0;
        let isCurDown = false;

        // только для десктопов
        if (!('ontouchstart' in window)) {
            $map.attr({
                'ondragstart': 'return false',
                'ondrop': 'return false'
            });

            $map.on('mousedown', function (e) {
                curXPos = mapScrollbar.offset.x + e.pageX;
                curYPos = mapScrollbar.offset.y + e.pageY;

                isCurDown = true;
            });

            $map.on('mousemove', function (e) {
                if (isCurDown) {
                    const new_pos_x = curXPos - e.pageX;
                    const new_pos_y = curYPos - e.pageY;

                    mapScrollbar.setPosition(new_pos_x, new_pos_y);
                    mapScrollbar.update();
                }
            });

            $map.on('mouseup mouseleave', function (e) {
                isCurDown = false;
            });
        }

        // выставим центр карты при загрузке страницы, особенно актуально для мобилок
        setTimeout(() => {
            if (mapScrollbar.limit.x > 0) {
                mapScrollbar.setPosition(parseInt(mapScrollbar.limit.x / 6), 0);

                if (window.innerWidth < 768) {
                    newPosX = 800;
                }
            }
        }, 10);
    }
    //initMapEvents();

    function onFormSubmit(evt) {
        requestPoints();

        evt.preventDefault();
    }

    function requestPoints() {
        $.ajax({
            data: $form.serialize(),
            url: mapPoints.url,
            type: mapPoints.method,
            success(res) {
                clearMarkers();
                renderPoints(res.points);
                initTooltip();
            },
        });
    }

    function clearMarkers() {
        $('.geography__map-point').remove();
        // markers.forEach((Marker) => {
        //     Marker.setMap(null);
        // });

        markers.length = 0;
    }

    function openSideDetail(url, mode) {
        const ajax = {
            method: 'post',
            url,
            data: {mode: mode},
        };

        $.ajax({
            ...ajax,
            success(asideHtml) {
                const $prevHtml = $asideContainer.children().detach();

                if ($prevHtml && $prevHtml.hasClass('map-side--region')) {
                    $asideContainer.data('$prevHtml', $prevHtml);
                }

                $asideContainer.html(asideHtml);
                $('body > .tooltip').css('visibility', 'hidden');
            },
        });
    }

    function renderPoints(points = []) {

        const map = $('.geography__map-svg');
        const mode = (typeof map.parent().data('mode') === 'undefined') ? 'default' : map.parent().data('mode');

        const isMobileViewport = !!window.matchMedia('(max-width: 767px)').matches;

        const NS = 'http://www.w3.org/2000/svg';
        const W3 = 'http://www.w3.org/1999/xlink';
        const assetsPath = '/local/templates/.default/assets/markers/';

        const gFogs = document.createElementNS(NS, 'g'); /* отдельный слой для картинок, не подвергающихся hover */
        gFogs.setAttributeNS(null, 'class', 'geography__map-fogs');
        map.append(gFogs);

        points.forEach((point, i) => {
            // создаем точки на карте из полученных данных
            const g = document.createElementNS(NS, 'g');
            g.setAttributeNS(null, 'class', 'geography__map-point');
            g.setAttributeNS(null, 'transform', `translate(${point.coordinates.latitude}, ${point.coordinates.longitude})`);
            g.setAttributeNS(null, 'data-regions', point.name);

             if (mode == 'eu') {  //фоны, тени и подсветки лежат на отдельном слое, чтобы не перекрывали балуны при ховере

                const gFog = document.createElementNS(NS, 'g');
                gFog.setAttributeNS(null, 'class', 'geography__map-fog');
                gFog.setAttributeNS(null, 'id', 'geography__map-fog-' + i);
                gFog.setAttributeNS(null, 'transform', 'translate(' + point.coordinates.latitude + ', ' + point.coordinates.longitude + ')');

                const image1 = document.createElementNS(NS, 'image');
                image1.setAttributeNS(null, 'x', '-24');
                image1.setAttributeNS(null, 'y', '-21');
                image1.setAttributeNS(null, 'width', 70);
                image1.setAttributeNS(null, 'height', 70);
                image1.setAttributeNS(null, 'class', 'geography__map-point-fog');
                image1.setAttributeNS(W3, 'href', assetsPath + 'geo_fog.svg');
                gFog.appendChild(image1);

                const image2 = document.createElementNS(NS, 'image');
                image2.setAttributeNS(null, 'x', '-8');
                image2.setAttributeNS(null, 'y', '-8');
                image2.setAttributeNS(null, 'width', 38);
                image2.setAttributeNS(null, 'height', 38);
                image2.setAttributeNS(null, 'class', 'geography__map-point-selected');
                image2.setAttributeNS(W3, 'href', assetsPath + 'geo_selected.svg');
                gFog.appendChild(image2);

                gFogs.appendChild(gFog);

                const image3 = document.createElementNS(NS, 'image');
                image3.setAttributeNS(null, 'x', 0);
                image3.setAttributeNS(null, 'y', 0);
                image3.setAttributeNS(null, 'width', 22);
                image3.setAttributeNS(null, 'height', 22);
                image3.setAttributeNS(null, 'class', 'geography__map-point-baloon');
                image3.setAttributeNS(null, 'data-id', i);
                image3.setAttributeNS(W3, 'href', assetsPath + 'geo_baloon.svg'); 
                g.appendChild(image3);

            } else {

                const image1 = document.createElementNS(NS, 'image');
                image1.setAttributeNS(null, 'x', 0);
                image1.setAttributeNS(null, 'y', 0);
                image1.setAttributeNS(null, 'width', isMobileViewport ? 100 : 60);
                image1.setAttributeNS(null, 'height', isMobileViewport ? 100 : 60);
                image1.setAttributeNS(null, 'class', 'geography__map-point-img');
                image1.setAttributeNS(W3, 'href', point.icon.url);
                g.appendChild(image1);

                const image2 = document.createElementNS(NS, 'image');
                image2.setAttributeNS(null, 'x', '-3');
                image2.setAttributeNS(null, 'y', '-11');
                image2.setAttributeNS(null, 'width', isMobileViewport ? 120 : 80);
                image2.setAttributeNS(null, 'height', isMobileViewport ? 120 : 80);
                image2.setAttributeNS(null, 'class', 'geography__map-point-hover');
                image2.setAttributeNS(W3, 'href', point.iconFocus.url);
                g.appendChild(image2);

            }

            map.append(g);
        });


        if (mode == 'eu') {

            if ($('html').hasClass('bx-ie')) {
                $('.geography__map-point-baloon, .geography__map-point-fog, .geography__map-point-selected').attr('transform', 'matrix(.416 0 0 .416 13 52 )');
            }

            // по клику открываем блок справа
            $('.geography__map-point-baloon').on('click', function (e) {
                const href = points[$(e.currentTarget).parent().index() - 2].url;
                openSideDetail(href, mode);
            });  

            //при наведении отображаем соответствующий бекграунд
            $('.geography__map-point-baloon').hover(
                e => {
                    const id = $(this).data('id');
                    map.find('#geography__map-fog-' + id + ' .geography__map-point-selected').css('opacity', '1');
                }, e => {
                    const id = $(this).data('id');
                    map.find('#geography__map-fog-' + id + ' .geography__map-point-selected').css('opacity', '0');
            });

            $asideContainer.on('click', '.map-side__close', e => {
                $asideContainer.html('');
            });

        } else {

            // по клику открываем попап
            $('.geography__map-point').on('click', e => {
                $.magnificPopup.open({
                    items: {
                        src: points[$(e.currentTarget).index() - 2].url,
                    },
                    type: 'ajax',
                    ...NLMK.magnificPopupDefaults,
                    mainClass: 'mfp-fade mfp-with-zoom mfp-geography',
                    callbacks: {
                        open() {},
                    },
                });
            });

            // при наведении меняем картинки
            $('.geography__map-point').hover(
                e => {
                    $(e.currentTarget).children('.geography__map-point-img').css('opacity', '0');
                    $(e.currentTarget).children('.geography__map-point-hover').css('opacity', '1');
                }, e => {
                    $(e.currentTarget).children('.geography__map-point-img').css('opacity', '1');
                    $(e.currentTarget).children('.geography__map-point-hover').css('opacity', '0');
            });

        }

        
    }
}



// WEBPACK FOOTER //
// ./js/main/module/geography/module.js